import { Button, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import './FolderPicker.css'
import Tree from './Tree/Tree';
import Actions, { FolderTemplate } from './Tree/ActionConst';
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { Col, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faFolder, faTimes } from '@fortawesome/free-solid-svg-icons';


// const structure = [
//     {
//         type: "folder",
//         name: "Parent Deal",
//         files: [
//             {
//                 type: "folder",
//                 name: "ui",
//                 files: [
//                     { type: "file", name: "Toggle.js" },
//                     { type: "file", name: "Button.js" },
//                     { type: "file", name: "Button.style.js" }
//                 ]
//             },
//             {
//                 type: "folder",
//                 name: "components",
//                 files: [
//                     { type: "file", name: "Tree.js" },
//                     { type: "file", name: "Tree.style.js" }
//                 ]
//             },
//             { type: "file", name: "setup.js" },
//             { type: "file", name: "setupTests.js" }
//         ]
//     },
//     {
//         type: "folder",
//         name: "packages",
//         files: [
//             {
//                 type: "file",
//                 name: "main.js"
//             }
//         ]
//     },
//     { type: "file", name: "index.js" }
// ];
// const structure = [
//     {
//         type: "folder",
//         readOnly: true,
//         name: "Parent Deal",
//         files: [],
//     },
// ];

export const FolderPicker = ({ value, onChange, open, setOpen }) => {

    let [data, setData] = useState(FolderTemplate);
    const [selectedObj,setSelectedObj] = useState()
    useEffect(k=>{
        setSelectedObj(value);
    },[value])
    const handleClick = props => {
        
        delete props["state"];
        setSelectedObj(props);
    };

    return (
        <Modal
            open={open}
            className='Folder-Picker-Modal'
            onClose={e => {
                setOpen(false);
            }}
            title={
                <div style={{ display: "flex",color: "#5b6c97" ,justifyContent: "space-between", alignItems: "center" }}>
                  <span><FontAwesomeIcon className='mr-1' icon={faFolder}/> Folder Explorer</span>
                  <span>
                  {selectedObj && selectedObj.path && <Button onClick={e=>{
                    setSelectedObj(null);
                    onChange(null);
                    // setOpen(false)
                  }} className='mr-1'>Clear</Button>}
                  {selectedObj && selectedObj.path && <Button onClick={e=>{
                    onChange(selectedObj);
                    setOpen(false)
                  }} className='mr-1' type="primary">Save</Button>}
                  <Button onClick={e=>setOpen(false)} icon={<FontAwesomeIcon icon={faTimes} />}></Button>
                  </span>
                </div>
              }
            onCancel={e => {
                setOpen(false);
            }}

            closeIcon={<></>}
            destroyOnClose
        >
            <Row className='p0m0 Sub-Header' style={{height:"5%"}} sm={12}>
                <span>{selectedObj && selectedObj.path}</span>
            </Row>
            <Row className='p0m0' style={{ height: "95%" }} sm={12}>
                {/* <ResizableBox
                    width={300}
                    // height={100%}
                    style={{height:"100%"}}
                    axis="x"
                    minConstraints={[300, Infinity]}
                    maxConstraints={[600, Infinity]}
                    resizeHandles={["e"]}
                > */}
                    <div style={{ height: "100%", overflow:"scroll" }}>
                        <Tree
                            selectedFile={selectedObj}
                            actionsAllowed={[Actions.ADD_FOLDER, Actions.DELETE, Actions.EDIT]}
                            // maxChiledAllow={1}
                            data={data}
                            // onUpdate={(d) => onChange(d)}
                            onNodeClick={handleClick}
                        />
                    </div>
                {/* </ResizableBox> */}

                {/* Right Panel */}
                {/* <div style={{ flex: 1, backgroundColor: "rgb(255 255 255)" }}>
                    <span style={{
                        height: "100%",
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: "0.2",
                        cursor:"default"
                    }}> 
                        <FontAwesomeIcon className='mr-1' size='lg' icon={faFileAlt} /> <span>No data to show</span> 
                    </span>
                </div> */}
            </Row>
        </Modal>
    )
}
